import ContextMessage from './ContextMessage';

export default ContextMessage;
